import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import { MainEventWithPagesFragmentDoc } from '../../fragments/generated/main-event.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MainEventQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type MainEventQuery = { __typename?: 'Query', mainEvent: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, content?: string | null, showScheduleLink?: boolean | null, position?: number | null, disableInfoAndProgram?: boolean | null, mainPageId?: string | null, createdAt: string, updatedAt: string, pages: Array<{ __typename?: 'Page', id: string, name: string, status: Types.StatusTypes, locale: string, description: string, content: string, createdAt: string, order?: number | null, updatedAt: string }>, logo?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } };


export const MainEventDocument = gql`
    query MainEvent($id: ID!) {
  mainEvent(id: $id) {
    ...mainEventWithPages
  }
}
    ${MainEventWithPagesFragmentDoc}`;

/**
 * __useMainEventQuery__
 *
 * To run a query within a React component, call `useMainEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMainEventQuery(baseOptions: Apollo.QueryHookOptions<MainEventQuery, MainEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainEventQuery, MainEventQueryVariables>(MainEventDocument, options);
      }
export function useMainEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainEventQuery, MainEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainEventQuery, MainEventQueryVariables>(MainEventDocument, options);
        }
export type MainEventQueryHookResult = ReturnType<typeof useMainEventQuery>;
export type MainEventLazyQueryHookResult = ReturnType<typeof useMainEventLazyQuery>;
export type MainEventQueryResult = Apollo.QueryResult<MainEventQuery, MainEventQueryVariables>;